//refer to read me for structure ref
const apiList = {
  login: {
    guest: `/login/guest`,
    refresh: `/login/refresh`,
  },
  logout: `/gw/api/logout`,
  captive: {
    getOtp: `/login/captive/otp`,
    local: `/login/captive/local`,
  },
  auth: {
    initiate: `/register/initiate`,
    validate: `/register/validate`,
  },
  homepage: {
    getProducts: `/pax2/v2/api/products/landingPage`,
    landingPageConstruct: `/pax2/v2/api/products/landingPageConstruct`,
    displayCollection: `/pax2/v2/api/products/displayCollection`,
  },
  stores: {
    getStores: `/pax2/v2/api/shops/getStores`,
  },
  products: {
    productDetail: `/pax2/v2/api/products/item`,
    productCategory: `/pax2/v2/api/products/category`,
    productId: `/pax2/v2/api/products/productId`,
  },
  cart: {
    summary: `/pax2/v2/api/cart/summary`,
    checkout: `/pax2/v2/api/cart/checkout`,
    myCart: `/pax2/v2/api/cart/mycart`,

    //V2
    summaryV2: `/pax2/v2/api/cart/v2/summary`,
    checkoutV2: `/pax2/v2/api/cart/v2/checkout`,
    myCartV2: `/pax2/v2/api/cart/v2/mycart`,
  },
  paymentSuccess: {
    orderSummary: `/pax2/v2/api/order/summary`,
  },
  paymentProcess: {
    paymentStatus: `/pax2/v2/api/order/paymentStatus/{{orderId}}`,
  },
  gate: {
    gateListing: `/fis/v2/api/aodb/gates`,
  },
  user: {
    info: `/gw/api/user/info`,
  },
  payment: {
    gatewayConfiguration: `/pax2/v2/api/payment/gatewayConfiguration`,
    cancel: `/pax2/v2/api/payment/cancel`,
    cancelByKey: `/pax2/v2/api/payment/cancelByKey`,
  },
  appOperatingLocation: {
    locationDetails: `/pax2/v2/api/location/locationDetails`,
  },
  braintreePayment: {
    paymentProcess: `/pax2/v2/api/payment/braintree/processPayment`,
  },
  cms: {
    alcoholAlert: `/cms/api/alcohol-alerts?populate=*`,
  },
  getCoupons: `/promotions/v1/api/promotion/getCoupons`,
  details: `pax2/v2/api/products/kioskDetails`,
  navbar: `/cms/api/navbars`,
  footer: `/cms/api/footer-v2s?populate[logo]=*`,
  pages: {
    privacyPolicy: `/cms/api/pages/kioskPrivacyPolicy`,
    termsOfService: `/cms/api/pages/kioskTermsOfService`,
    disclaimer: `/cms/api/pages/kioskDisclaimer`,
    payment: `/cms/api/pages/kioskPayment`,
  },
  appEnvProps: {
      envProps: `/cms/api/config-v2s?populate=*`,
  },
};

export default apiList;
